import React, { Component } from "react";
import { Container, Row, Button } from "reactstrap";
import { Link } from "react-router-dom";

import "./Login.css";
import Logo from "../../components/Logo/Logo";
import LoginSide from "../../components/LoginSide/LoginSide";
import { isTrivvyProduct } from "../../utils/constants";
import trivvyLogo from "../../assets/trivvy/trivvy-logo-img.png";
class ResetLinkSendSuccess extends Component {
  handleReturnToLogin = () => {
    this.props.history.push({
      pathname: "login",
      state: {
        isFromResetLink: true,
      },
    });
  };

  render() {
    return (
      <Container className="login-layout-container">
        <Row className="login-outer-wrapper">
          <div id="login-main" className="col-sm-10 col-md-10 login-card-box">
            <div id="login-main-wrapper" className="white-background">
              {isTrivvyProduct() ? (
                <div className="login-container-title-trivvy">
                  <img src={trivvyLogo} className="trivvy-logo-img" />
                  <span className="sidebar-trivvy-logo-txt-lg">Trivvy</span>
                </div>
              ) : (
                <Logo />
              )}

              <div className="text-left mt50 reset-password-title">
                Reset Link Sent
              </div>
              <div className="text-left mt10 reset-link-desc">
                A password reset link has been sent to the email address you
                provided.
              </div>
              <div className="text-left mt20 reset-link-desc">
                If you don't see it in a couple of minutes, check your spam
                folder. It was sent from{" "}
                <span className="primary-color">team@ouroffice.io</span>
              </div>
              <div className="text-center mt30">
                <Button
                  className="btn-send-reset-link"
                  onClick={this.handleReturnToLogin}
                >
                  <span className="txt-send-reset-link">Return to Login</span>
                </Button>
              </div>
            </div>
          </div>
		  {
			 ! isTrivvyProduct() &&  <LoginSide />
		  }
         
        </Row>
        <Row>
          <div id="login-secondary" className="col-sm-12 mb10 pl30">
            <div className="text-center">
              © {new Date().getFullYear()}{" "}
              <a href="https://www.ouroffice.io/">OurOffice, Inc</a>
            </div>
          </div>
        </Row>
      </Container>
    );
  }
}

export default ResetLinkSendSuccess;
